export const leadStatusesName = [
  "New Lead",
  "Not Qualified",
  "Qualified",
  "Contact Attempted",
  "In Progress",
  "Converted",
  "Closed-Won",
  "Closed-Lost",
];
const loginUserAFP =
  JSON.parse(localStorage.getItem("loginData") || "{}")?.tenantDetails
    ?.tenantType === "Tenant"
    ? ["AFP"]
    : [];

export const leadSourcesName = [
  ...[
    "Advertisement",
    "Agent",
    "Call",
    "Chatbot",
    "Email Query",
    "External Referral",
    "X (Twitter)",
    "Facebook",
    "Public Relations",
    "Sales Email",
    "Seminar Partner",
    "Internal Seminar",
    "Web Research",
    "Horizon",
    "Manual",
    "Website",
    "Partner",
    "MemorialGo",
    "AI Voice Agent",
  ],
  ...loginUserAFP,
];

export const myCampaignsName = ["Planning", "Active", "Completed"];

export const seriesPayload = {
  innerRadius: 45,
  outerRadius: 80,
  paddingAngle: 1,
  cornerRadius: 4,
};

export const myCampaignsNameColors = ["#5D5FEF", "#EF5DA8", "#F57C00"];

export const leadStatusesNameColors = [
  "#BD3D44",
  "#6A1B9A",
  "#FFA447",
  "#1976D2",
  "#00C853",
  "#FF5E5E",
  "#FFD600",
  "#263238",
];
